import type { BooleanOperationFilterInput, StringOperationFilterInputTypeExFilterInput } from 'gql/graphql';

const workKindFiltersNames = ['workInSum', 'workName'];

export const getPriceListWhereVariables = (filterValues: Record<string, string[]>) => {
    const plainFilters = Object.entries(filterValues)
        .filter((f) => !workKindFiltersNames.includes(f[0]))
        .reduce<
            Record<string, BooleanOperationFilterInput | Pick<StringOperationFilterInputTypeExFilterInput, 'in'>>[]
        >((acc, [key, value]) => {
            if (value.length) {
                const isBooleanFilter = [
                    'isIncludedInWorkOrder',
                    'isIncludedInAct',
                    'isIncludedInWorkOrderChange',
                ].includes(key);

                acc = [
                    ...acc,
                    {
                        [key]: isBooleanFilter ? { eq: value[0] === 'Да' } : { in: value },
                    },
                ];
            }

            return acc;
        }, []);

    const workKindFilters = Object.entries(filterValues)
        .filter((f) => workKindFiltersNames.includes(f[0]))
        .reduce<
            Record<string, BooleanOperationFilterInput | Pick<StringOperationFilterInputTypeExFilterInput, 'in'>>[]
        >(
            (acc, [key, value]) =>
                !value.length
                    ? acc
                    : [
                          ...acc,
                          {
                              [key]: { in: value },
                          },
                      ],
            [],
        );

    return plainFilters.length || workKindFilters.length
        ? {
              ...(plainFilters.length ? { and: plainFilters } : {}),
              ...(workKindFilters.length ? { workKind: { and: workKindFilters } } : {}),
          }
        : undefined;
};
